import * as React from 'react';

import FilePresentation16 from './FilePresentation16';

export const filePresentation16 = () => <FilePresentation16 />;

export default {
    title: 'Icon|Fill|FilePresentation16',
    component: FilePresentation16,
    parameters: {
        notes: "`import FilePresentation16 from 'box-ui-elements/es/icon/fill/FilePresentation16';`",
    },
};
